const translations = {
    batteryNameFieldLabel: 'Battery Name'
};

export default translations;
